module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_OpenInNewWindow_16"],"path":[{"$":{"d":"M13,10h2v5H1V1H6V3H3V13H13ZM9,1l2.22,2.22L5.33,9.11l1.56,1.56,5.89-5.89L15,7V1Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_OpenInNewWindow_16.svg
// module id = yrtS
// module chunks = 1